'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import useRudderStackAnalytics from '@/hooks/useRudderAnalytics';
import { AppDownloadModal } from '@/components/donwload-app-modal-lp';
import { useIsMobile } from '@/hooks/use-mobile';
import { motion, useScroll, useTransform } from 'framer-motion';
import useIsWebview from '@/hooks/use-is-webview';
const Navigation = () => {
  const $ = _c(48);
  const [modalApp, setModalApp] = useState(false);
  const isMobile = useIsMobile();
  const analytics = useRudderStackAnalytics();
  const {
    scrollY
  } = useScroll();
  const [isWebView] = useIsWebview();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [0, 100];
    t1 = ["blur(8px)", "blur(20px)"];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const backdropFilter = useTransform(scrollY, t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [0, 100];
    t3 = ["0 0 0 rgba(0, 0, 0, 0)", "0 4px 12px rgba(0, 0, 0, 0.1)"];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const boxShadow = useTransform(scrollY, t2, t3);
  let t4;
  if ($[4] !== analytics || $[5] !== isWebView) {
    t4 = () => {
      analytics?.track("CTA Clicked", {
        cta_name: "login_header",
        cta_location: "lp_header",
        cta_type: "login",
        platform: isWebView ? "app" : "web"
      });
    };
    $[4] = analytics;
    $[5] = isWebView;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleLoginClick = t4;
  let t5;
  if ($[7] !== analytics || $[8] !== isMobile) {
    t5 = () => {
      if (!isMobile) {
        setModalApp(true);
        return;
      }
      analytics?.track?.("CTA Clicked", {
        cta_name: "download_app",
        cta_type: "app",
        cta_location: "lp_header"
      });
      window.open("https://nimble.li/p9lx4pv9", "_blank");
    };
    $[7] = analytics;
    $[8] = isMobile;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleDownloadAppClick = t5;
  let t6;
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0
    };
    t7 = {
      opacity: 1
    };
    t8 = {
      duration: 0.3
    };
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== modalApp) {
    t9 = <AppDownloadModal open={modalApp} setOpen={setModalApp} />;
    $[13] = modalApp;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== backdropFilter || $[16] !== boxShadow) {
    t10 = {
      backdropFilter,
      boxShadow
    };
    $[15] = backdropFilter;
    $[16] = boxShadow;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  let t12;
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 0,
      y: -20
    };
    t12 = {
      opacity: 1,
      y: 0
    };
    t13 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t11 = $[18];
    t12 = $[19];
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <motion.div initial={t11} animate={t12} transition={t13} className="h-[32px] w-[98px] md:h-[39.818px] md:w-[121.488px] relative shrink-0"><Image src="/images/pierre-logo-navbar.webp" alt="Pierre logo" width={121} height={40} className="object-contain hidden dark:block" priority={true} /><Image src="/images/pierre-logo-navbar-light.png" alt="Pierre logo" width={121} height={40} className="object-contain dark:hidden" priority={true} /></motion.div>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  let t16;
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 0
    };
    t16 = {
      opacity: 1
    };
    t17 = {
      duration: 0.5,
      delay: 0.7
    };
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t15 = $[22];
    t16 = $[23];
    t17 = $[24];
  }
  let t18;
  if ($[25] !== handleLoginClick) {
    t18 = () => {
      handleLoginClick();
    };
    $[25] = handleLoginClick;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Button variant="pierre" size="xl" type="button" rounded="full" className="hidden md:inline-flex text-xs md:text-base px-3 md:px-6 py-1.5 md:py-4 ">Crie uma conta</Button>;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t18) {
    t20 = <motion.div initial={t15} animate={t16} transition={t17}><Link href="/login" onClick={t18}>{t19}</Link></motion.div>;
    $[28] = t18;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  let t22;
  let t23;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      opacity: 0
    };
    t22 = {
      opacity: 1
    };
    t23 = {
      duration: 0.5,
      delay: 0.6
    };
    $[30] = t21;
    $[31] = t22;
    $[32] = t23;
  } else {
    t21 = $[30];
    t22 = $[31];
    t23 = $[32];
  }
  let t24;
  if ($[33] !== handleDownloadAppClick || $[34] !== isMobile || $[35] !== isWebView) {
    t24 = !isWebView && <Button onClick={handleDownloadAppClick} variant={isMobile ? "pierre" : "link"} size="xl" rounded="full" className="text-xs md:text-base hover:scale-105 transition-all ease-out px-3 md:px-6 py-1.5 md:py-4"><span className="hidden sm:inline">Baixar APP</span><span className="sm:hidden">Baixar APP</span></Button>;
    $[33] = handleDownloadAppClick;
    $[34] = isMobile;
    $[35] = isWebView;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t24) {
    t25 = <motion.div initial={t21} animate={t22} transition={t23}>{t24}</motion.div>;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t20 || $[40] !== t25) {
    t26 = <div className="flex items-center gap-2 md:gap-4 shrink-0">{t20}{t25}</div>;
    $[39] = t20;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t10 || $[43] !== t26) {
    t27 = <div className="w-full max-w-screen-xl flex items-center justify-between"><motion.div style={t10} className="w-full backdrop-blur-sm border dark:border-neutral-600 border-neutral-200 rounded-full px-3 py-2 md:px-6 md:py-3 lg:px-[26px] flex items-center justify-between gap-2 md:gap-4 transition-all">{t14}{t26}</motion.div></div>;
    $[42] = t10;
    $[43] = t26;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t27 || $[46] !== t9) {
    t28 = <motion.nav initial={t6} animate={t7} transition={t8} className="fixed top-0 inset-x-0 z-50 flex items-center justify-center pt-6 px-4 md:px-8 lg:px-[40px]">{t9}{t27}</motion.nav>;
    $[45] = t27;
    $[46] = t9;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  return t28;
};
export default Navigation;